import React from 'react';

import { StyledSkeletonLayout } from './styles';
import { SkeletonLayoutProps } from './types';

/** Utility component for rendering a skeleton component while loading */
export const SkeletonLayout: React.FC<SkeletonLayoutProps> = ({
  children,
  fallback: layout,
  isLoading,
  $width,
  $height,
}) => {
  return (
    <StyledSkeletonLayout $height={$height} $width={$width}>
      {isLoading ? layout : children}
    </StyledSkeletonLayout>
  );
};
